module.exports = __webpack_public_path__ + "img/share-drawer.948c7d99.png";